<template>
  <div class="page-container">
    <div class="page-header">
      采集到收藏夹
    </div>
    <div class="collect-box">
      <!--  -->
      <Row type="flex" justify="space-between" align="top">
        <Col span="12" class="left-main">
          <div class="imgs-show">
            <div class="left">
              <div
                class="source-img"
                v-for="(source, index) in sourceArr"
                :style="{ 'background-image': 'url(' + source.url + ')' }"
                :key="index"
              >
                <div class="cover-bg" v-if="collectStatus > 0">
                  <div v-if="source.status == 1" class="tip">
                    <img src="../images/green-hook.png" alt="" />
                    <p>采集成功</p>
                  </div>
                  <div v-if="source.status == 2" class="tip">
                    <img src="../images/notice-red.png" alt="" />
                    <p>采集失败</p>
                  </div>
                  <div v-if="source.status == 3" class="tip">
                    <img src="../images/notice.png" alt="" />
                    <p>已采集</p>
                  </div>
                  <div class="spin-load" v-if="source.status == 4">
                    <Spin fix>
                      <div class="loader">
                        <svg class="circular" viewBox="25 25 50 50">
                          <circle
                            class="path"
                            cx="50"
                            cy="50"
                            r="20"
                            fill="none"
                            stroke-width="5"
                            stroke-miterlimit="10"
                          ></circle>
                        </svg>
                      </div>
                    </Spin>
                  </div>
                </div>
                <div
                  class="delete-icon"
                  v-if="collectStatus == 0"
                  @click="removeSource(index)"
                ></div>
              </div>
              <div
                class="source-img"
                v-for="(n, index) in 12 - sourceArr.length"
                :key="index"
              ></div>
            </div>
            <div class="right">
              <p v-if="collectStatus == 0">
                (已选择 {{ sourceArr.length }} 张)
              </p>
              <p v-if="collectStatus == 1">(已采集成功 {{ successNum }} 张)</p>
              <p v-if="collectStatus == 2">(采集成功 {{ successNum }} 张)</p>
            </div>
          </div>
        </Col>
        <Col span="12" style="padding-top: 30px;">
          <div class="search-fav">
            <i class="iconfont icon-sousuo"></i>
            <input
              type="text"
              v-model="keyword"
              placeholder="查找收藏夹"
              @keyup="search"
              @blur="onSearch"
            />
          </div>
          <div class="favs-select" v-if="!busy && favList.length">
            <div class="fav-list">
              <div class="fav" :key="index" v-for="(item, index) in favList">
                <!-- :class="{ active: selectedFavId == item.id }" -->
                <!-- @click="setFav(item)" -->
                <span class="name">{{ item.name }}</span>
                <span v-if="selectedFavId == item.id" class="red-font"
                  ><i class="iconfont icon-wancheng-copy"></i
                ></span>
                <button
                  class="red-btn item-red-btn"
                  @click="collectItem(item)"
                  v-if="collectStatus != 2 && selectedFavId !== item.id"
                  :disabled="collectStatus == 1 || sourceArr.length < 1"
                >
                  采集
                </button>
              </div>
            </div>
            <div class="btn-footer">
              <!-- <button
                class="red-btn"
                @click="complete"
                v-if="collectStatus == 2"
              >
                关闭窗口
              </button> -->

              <!-- <button
                class="red-btn"
                @click="collect"
                v-else
                :disabled="collectStatus == 1 || sourceArr.length < 1"
              >
                采下来
              </button> -->

              <Button
                size="large"
                icon="md-add"
                type="primary"
                shape="circle"
                @click="newFav"
              ></Button>
              <span class="desc">创建收藏夹</span>
              <!-- <button class="main-btn" @click="newFav">创建收藏夹</button> -->
            </div>
          </div>
        </Col>
      </Row>

      <div class="no-result" v-if="!busy && !favList.length">
        <div v-if="keyword.trim()">
          <img src="../../../../images/cut/search_no_result.png" alt="" />
          <p>没有相关的收藏夹</p>
        </div>
        <div v-else>
          <img src="../../../../images/cut/fav_null.png" alt="" />
          <p>你还没有创建任何收藏夹</p>
        </div>
      </div>
    </div>
    <create-fav
      ref="createFav"
      @createSuccess="createSuccessHandle"
    ></create-fav>

    <div class="modelSuccess">
      <Modal
        v-model="modelSuccess"
        title="斑斓采集"
        :mask-closable="false"
        width="400"
        :closable="false"
      >
        <div style="margin-top:-30px;">
          <i
            v-if="successNum > 0"
            style="font-size: 30px;color: #44D7B6;"
            class="iconfont icon-wancheng-copy"
          ></i>
        </div>
        <p style="text-align:center;font-size: 16px;" v-if="successNum > 0">
          已成功采集{{ successNum }}张照片到<span style="font-weight: bold;"
            >&nbsp;&nbsp;{{ getName(selectedFavId) || '未知文件夹' }}</span
          >
        </p>
        <p style="text-align:center;font-size: 16px;" v-if="successNum <= 0">
          采集失败
        </p>
        <div>
          <a
            v-if="successNum > 0"
            target="_blank"
            :href="
              VUE_APP_NEXT_BASIC_URL + '/my-collect-detail/' + selectedFavId
            "
          >
            <button
              style="width: 150px;
                    height: 40px;
                    margin-top: 40px;"
              class="red-btn"
            >
              前往查看
            </button>
          </a>
          <button
            v-if="successNum <= 0"
            @click="reloadHandle"
            style="width: 150px;
                    height: 40px;
                    margin-top: 40px;"
            class="red-btn"
          >
            重新采集
          </button>

          <p
            v-if="successNum > 0"
            style="margin-top: 5px;
    color: #707070"
          >
            {{ timeNum }}秒后将自动关闭窗口
          </p>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import api from '../../../../api'
import createFav from './createFav'
import axios from 'axios'
export default {
  data() {
    return {
      VUE_APP_NEXT_BASIC_URL: process.env.VUE_APP_NEXT_BASIC_URL,
      imgBaseUrl: api.common.imgBaseUrl,
      favList: [],
      oldFavlist: [],
      selectedFavId: undefined,
      busy: false,
      keyword: '',
      sourceArr: [],
      alreadyArr: [],
      successNum: 0,
      collectStatus: 0, //0 未开始 1 采集中 2 已完成
      modelCreate: false,
      modelSuccess: false,
      timeNum: 5,
    }
  },
  components: { createFav },
  methods: {
    createSuccessHandle() {
      this.getCollections()
    },
    getCollections() {
      this.busy = true
      api.collections.getFavorites().then((res) => {
        this.favList = res
        this.oldFavlist = res
        // this.setFav(res[0]);
        this.busy = false
      })
    },
    setFav(item) {
      this.selectedFavId = item.id
    },
    /* 单个项目采集 */
    collectItem(item) {
      this.setFav(item)
      this.collect()
    },

    collect() {
      //采集逻辑
      this.collectStatus = 1
      this.asyncCollect(0)
    },
    reloadHandle() {
      this.modelSuccess = false
      this.collectStatus = 0
      this.selectedFavId = ''
    },
    asyncCollect(index) {
      let source = this.sourceArr[index]
      if (!source) {
        this.collectStatus = 2
        this.postMessage({ complete: true, urls: this.alreadyArr }, '*')
        this.modelSuccess = true
        this.closeWin()
        return
      }
      source.status = 4 // 1  completed 2 error 3 already 4 uploading
      // collection_v2
      api.inspirations
        .collection({
          url: source.url,
          describe: source.describe,
          origin: source.origin,
          favoriteId: this.selectedFavId,
        })
        .then(
          (res) => {
            source.status = res
            //res 1 success 2 error 3 already
            res != 2 && this.alreadyArr.push(source.url)
            res == 1 && this.successNum++
            this.asyncCollect(index + 1)
          },
          () => {
            source.status = 2
            this.asyncCollect(index + 1)
          }
        )
    },
    complete() {
      this.close()
    },
    close() {
      //关闭自身窗口 ,window.close() 会关闭有 window 指定的顶层浏览器窗口
      // self.close()
      window.close()
    },
    newFav() {
      this.$refs.createFav.open()
      //   this.$router.push({ name: "widgetsNewFav" });
    },
    search(e) {
      if (e.key == 'Enter' || e.keyCode == 13) {
        this.onSearch()
      }
    },
    onSearch() {
      this.favList = this.oldFavlist.filter((item) => {
        if (item.name.indexOf(this.keyword) > -1) {
          return item
        }
      })
    },
    receiveMessage(event) {
      if (event.source === window.opener) {
        //执行收藏逻辑
        //执行完毕之后,发出pin Complete message
        this.sourceArr = JSON.parse(event.data)
      }
    },
    init() {
      this.postMessage('multipleCollect', '*')
      let e = window.addEventListener
        ? window.addEventListener
        : window.attachEvent
      e('message', this.receiveMessage, false)
    },
    postMessage(data, origin = '*') {
      data == undefined && (data += '')
      if (window.opener) {
        window.opener.postMessage(JSON.stringify(data), origin)
      }
    },
    removeSource(index) {
      this.sourceArr.splice(index, 1)
    },
    /* 等待关闭窗口 */
    closeWin() {
      var timer = setInterval(() => {
        this.timeNum = this.timeNum - 1
        if (this.timeNum <= 0) {
          clearInterval(timer)
          this.successNum > 0 ? this.close() : ''
        }
      }, 1000)
    },

    /* 获得名字 */
    getName(id) {
      var lists = this.favList.filter((item) => item.id === id),
        name = null
      if (lists.length > 0) {
        name = lists[0].name
      }
      return name
    },
  },
  created() {
    this.getCollections()
    this.init()
  },
}
</script>
<style>
.widgets .spin-load .ivu-spin-fix {
  background-color: transparent;
}
</style>
<style scoped type="text/scss" lang="scss">
@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}

@-webkit-keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

@keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.page-container {
  .page-header {
    height: 90px;
    line-height: 90px;
    font-size: 24px;
    letter-spacing: 4px;
    text-align: center;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.0983073);
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.0983073);
    // margin-bottom: 30px;
  }
  .collect-box {
    padding: 0 10px;
    .left-main {
      height: 545px;
      padding-top: 30px;
      //   box-shadow: 2px 0px 1px rgba(0, 0, 0, 0.100345);
    }
    .imgs-show {
      //   height: 160px;
      height: 100%;
      .left {
        float: left;
        // width: 400px;
        width: 100%;
        height: 100%;
        text-align: left;
        .source-img {
          width: 83px;
          height: 83px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          background-color: #ebeff0;
          margin-right: 10px;
          margin-bottom: 10px;
          float: left;
          display: block;
          position: relative;
          &:hover .delete-icon {
            display: block;
          }
          .delete-icon {
            width: 20px;
            height: 20px;
            position: absolute;
            top: 4px;
            right: 4px;
            opacity: 0.9;
            background-image: url('../images/delete.png');
            display: none;
            &:hover {
              background-image: url('../images/delete-hover.png');
            }
          }
        }
        .cover-bg {
          width: 83px;
          height: 83px;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          background-color: rgba(53, 56, 56, 0.6);
          .spin-load {
            .loader {
              width: 30px;
              height: 30px;
              position: relative;
              margin: 0 auto;
              .circular {
                -webkit-animation: rotate 2s linear infinite;
                animation: rotate 2s linear infinite;
                height: 100%;
                -webkit-transform-origin: center center;
                transform-origin: center center;
                width: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                .path {
                  stroke-dasharray: 1, 200;
                  stroke-dashoffset: 0;
                  -webkit-animation: dash 1.5s ease-in-out infinite,
                    color 6s ease-in-out infinite;
                  animation: dash 1.5s ease-in-out infinite,
                    color 6s ease-in-out infinite;
                  stroke-linecap: round;
                  stroke: #3dbd7d;
                }
              }
            }
          }
          .tip {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            img {
              display: inline-block;
              width: 24px;
              height: 24px;
              margin: 12px 0 4px;
            }
            p {
              font-size: 12px;
              color: #fff;
            }
          }
        }
      }
      .right {
        position: absolute;
        bottom: 17px;
        text-align: center;
        width: 100%;
        p {
          font-size: 14px;
          color: #353838;
        }
      }
    }
    .search-fav {
      //   background: #edeff0;
      border: 1px solid #bdbdbd;
      height: 40px;
      text-align: left;
      font-size: 14px;
      margin-bottom: 10px;
      width: 95%;
      .iconfont {
        color: #6c6f70;
        font-size: 20px;
        margin-right: 8px;
        margin-left: 8px;
        vertical-align: middle;
      }
      input {
        width: 86%;
        height: 40px;
        border: 0 none;
        background-color: transparent;
        font-size: 14px;
        &::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #6c6f70;
          font-size: 14px;
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #6c6f70;
          font-size: 14px;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #6c6f70;
          font-size: 14px;
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #6c6f70;
          font-size: 14px;
        }
      }
      button {
        width: 120px;
        height: 32px;
        line-height: 32px;
        vertical-align: middle;
      }
    }
    .favs-select {
      .fav-list {
        height: 380px;
        overflow-y: auto;
        .fav {
          height: 52px;
          line-height: 52px;
          background-color: #fff;
          text-align: left;
          padding: 0 10px;
          position: relative;
          .red-font {
            position: absolute;
            right: 10px;
            top: 0;
            i {
              font-size: 18px;
              color: #44d7b6;
            }
          }
          span.name {
            font-size: 14px;
            display: inline-block;
            width: 70%;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;
            font-weight: bold;
          }
          &:hover {
            background: #f7f9fa;
            .item-red-btn {
              display: inline;
            }
          }
          &.active {
            background: #f7f9fa;
            .red-font {
              display: block;
            }
          }
        }
      }
      .btn-footer {
        // text-align: center;
        text-align: left;
        margin-top: 35px;
        button {
          background: #eb5757;
          border: 1px solid #eb5757;
          //   width: 132px;
          //   height: 40px;
          &:first-child {
            // margin-right: 60px;
          }
          &.cancel-btn {
            background: #ffffff;
            // border: 1px solid #6c6f70;
          }
        }
        .desc {
          font-size: 16px;
          color: #313131;
          vertical-align: middle;
          display: inline;
          margin-left: 8px;
        }
      }
    }
    .no-result {
      padding-top: 14px;
    }
  }
  .item-red-btn {
    float: right;
    height: 32px;
    line-height: 32px;
    width: 72px;
    margin-top: 10px;
    display: none;
  }
}
</style>
